module.exports = __webpack_public_path__ + "img/c_jj.a041f8ba.png";